import Svg, { Path } from 'react-native-svg';

// Apple's silhouette mark, monochrome (fill inherits from the caller so
// it renders white-on-black per Apple's own "Sign in with Apple"
// button spec, same reasoning as GoogleLogo -- the mark isn't recolored
// into this app's brand palette).
export function AppleLogo({ size = 18, color = '#ffffff' }: { size?: number; color?: string }) {
  return (
    <Svg width={size} height={size} viewBox="0 0 24 24">
      <Path
        fill={color}
        d="M16.365 1.43c0 1.14-.437 2.163-1.166 2.928-.83.87-2.05 1.517-3.15 1.435-.13-1.098.44-2.243 1.155-2.988C13.98.99 15.29.28 16.35 0c.01.144.014.288.014.43zM20.5 17.44c-.518 1.15-.766 1.665-1.435 2.688-.933 1.425-2.25 3.2-3.879 3.213-1.443.014-1.816-.94-3.775-.925-1.96.013-2.368.94-3.812.928-1.629-.014-2.876-1.62-3.808-3.046C1.06 17.32.166 13.4 1.51 10.727c.822-1.62 2.286-2.65 3.875-2.663 1.556-.014 3.025 1.048 3.976 1.048.95 0 2.734-1.298 4.61-1.108.786.033 2.994.318 4.411 2.394-.113.07-2.633 1.537-2.605 4.586.03 3.646 3.196 4.855 3.234 4.87-.026.077-.502 1.72-1.512 3.586z"
      />
    </Svg>
  );
}
